module.exports = __webpack_public_path__ + "static/media/may_memoji_421x421.c0acb0a1.png";